
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 10">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.8067 4.64689C13.8537 4.73326 13.884 4.78907 13.8984 4.80717L14.051 5.00015L13.8984 5.19306C13.8841 5.21118 13.8537 5.267 13.8067 5.3534L13.8067 5.35343C13.3456 6.20078 11.2845 9.98851 7.0511 9.98851C2.81759 9.98851 0.756415 6.20058 0.295404 5.35336C0.248407 5.26699 0.218039 5.21118 0.203695 5.19306L0.0510254 5.00015L0.203625 4.80717C0.217969 4.78905 0.248337 4.73325 0.295334 4.64688C0.756345 3.79965 2.81752 0.0117188 7.05103 0.0117188C11.2845 0.0117188 13.3457 3.79971 13.8067 4.64689ZM1.32685 5.63854C2.2238 6.95296 3.8682 9.36271 7.0511 9.36271C10.2386 9.36271 11.8808 6.95251 12.7763 5.63823L12.7764 5.63822C12.9591 5.37 13.1108 5.14742 13.2381 5.00029C13.1105 4.85309 12.9585 4.63029 12.7753 4.36177C11.8784 3.04736 10.234 0.63752 7.0511 0.63752C3.86367 0.63752 2.22142 3.04758 1.32585 4.36187C1.14302 4.63016 0.991318 4.8528 0.863935 4.99994C0.991538 5.14715 1.14359 5.36998 1.32685 5.63854ZM7.0511 3.00363C5.94741 3.00363 5.04945 3.89935 5.04945 5.00029C5.04945 6.1013 5.94741 6.99702 7.0511 6.99702C8.15486 6.99702 9.05275 6.1013 9.05275 5.00029C9.05275 3.89935 8.15479 3.00363 7.0511 3.00363ZM5.71809 5.00036C5.71809 5.7336 6.31603 6.33002 7.0511 6.33002C7.7861 6.33002 8.38404 5.7336 8.38411 5.00036C8.38411 4.26712 7.78617 3.6707 7.0511 3.6707C6.31603 3.6707 5.71809 4.26712 5.71809 5.00036Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'View',
    }) as DefineComponent
    </script>
    